import { MaterialCreationProcess } from 'api';

import type { WithOptional } from '../../utils/types';
import { SelectField, type SelectFieldProps, type SelectOption } from '../SelectField/SelectField';

const DEFAULT_OPTIONS: SelectOption[] = MaterialCreationProcess && [
  { label: 'Hand Picked', value: MaterialCreationProcess.HAND_PICKED },
  { label: 'Mechanical', value: MaterialCreationProcess.MECHANICAL },
];

const OPTIONS_WITH_NOT_AVAILABLE: SelectOption[] = MaterialCreationProcess && [
  ...DEFAULT_OPTIONS,
  { label: 'N/A', value: undefined },
];

type Props = Omit<WithOptional<SelectFieldProps, 'name' | 'required' | 'label'>, 'options'> & {
  withNotAvailable?: boolean;
};

export const MaterialCreationProcessSelectField = ({
  name = 'creation_process',
  label = 'Material process',
  withNotAvailable = true,
  required = false,
  ...rest
}: Props) => {
  return (
    <SelectField
      label={label}
      name={name}
      required={required}
      options={withNotAvailable ? OPTIONS_WITH_NOT_AVAILABLE : DEFAULT_OPTIONS}
      {...rest}
    />
  );
};
